/**
 * Lake house LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * LP trade registration DTO
 */
export interface RegisterTradeRequest {
  /**
   * Base pair ID
   */
  pairId: number;
  /**
   * LP for trade registration
   */
  liquidityProviderId: number;
  quantity: number;
  price: number;
  side: RegisterTradeRequest.SideEnum;
}
export namespace RegisterTradeRequest {
  export const SideEnum = {
    Buy: 'BUY',
    Sell: 'SELL',
  } as const;
  export type SideEnum = (typeof SideEnum)[keyof typeof SideEnum];
}
